import { render, staticRenderFns } from "./CreateWallet.vue?vue&type=template&id=44f94094&scoped=true"
import script from "./CreateWallet.vue?vue&type=script&lang=js"
export * from "./CreateWallet.vue?vue&type=script&lang=js"
import style0 from "./CreateWallet.vue?vue&type=style&index=0&id=44f94094&prod&lang=css"
import style1 from "./CreateWallet.vue?vue&type=style&index=1&id=44f94094&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f94094",
  null
  
)

export default component.exports